<template>
  <a :class="{ selected: selected, light: light }" class="uikit_list_item" @click="callback">
    <uikit-icon v-if="icon" :name="icon" />
    <h5>{{ name }}</h5>
  </a>
</template>

<script>
import UikitIcon from "./component.uikit.icon.vue";

export default {
  name: "uikitListItem",
  components: {
    UikitIcon,
  },
  props: {
    icon: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "Hello World",
    },
    selected: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      default: () => {
        console.log("oops...");
      },
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.uikit_list_item {
  display: flex;
  flex-direction: row;
  background: transparent;
  padding: 0.75rem;
  border-radius: 0.375rem;
  gap: 0.75rem;
  cursor: pointer;
  transition: all 0.25s;
}
.uikit_list_item:hover {
  background: rgb(42, 43, 50);
}
.uikit_list_item.selected {
  background: #343541 !important;
}
.uikit_list_item.light {
  background: #3e3f4b !important;
  margin-top: 16px
}
.uikit_list_item.light:hover{
  background: #202123!important;
}
</style>
